/// <reference types="react-dom" />

import React = require("react");
import ReactDOM = require("react-dom");

import Component_Base = require("VSS/Flux/Component");
import Navigation_Services = require("VSS/Navigation/Services");
import Utils_String = require("VSS/Utils/String");
import Utils_Core = require("VSS/Utils/Core");

import { Fabric } from "OfficeFabric/Fabric";

import { IHubViewState, HubViewState } from "VSSUI/Utilities/HubViewState";
import { Hub } from "VSSUI/Hub";
import { HubHeader } from "VSSUI/HubHeader";
import { PivotBarItem } from 'VSSUI/PivotBar';

import BuildResources = require("Build/Scripts/Resources/TFS.Resources.Build");
import { AdminConcurrentJobsView } from "Build/Scripts/AdminBuildAndRelease/Components/AdminConcurrentJobsView";
import { NavigationScenario, NavigationScenarios, startPageLoadScenario } from "Build/Scripts/Performance";
import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");

export interface AdminBuildAndReleaseHubState extends Component_Base.State {
    view: string;
    tab: string;
}

export class AdminBuildAndReleaseHub extends Component_Base.Component<Component_Base.Props, AdminBuildAndReleaseHubState> {

    private _hubViewState: IHubViewState;
    private _performance: NavigationScenario;
    private _settingsKey: string = 'settings';
    private _resourceLimitsKey: string = 'resourceLimits';
    private _concurrentJobsKey: string = 'concurrentJobs';
    private _showConcurrentJobsTab: boolean;

    constructor(props: Component_Base.Props) {
        super(props);

        this._performance = startPageLoadScenario(NavigationScenarios.AdminBuildAndReleaseHub);

        let state = this._getState();
        this._hubViewState = new HubViewState({
            defaultPivot: state.tab
        });
        this._urlStateChangeDelegate = Utils_Core.delegate(this, this._onUrlChange);
        this._showConcurrentJobsTab = TFS_Host_TfsContext.TfsContext.getDefault().isHosted;
    }

    public componentDidMount(): void {
        super.componentDidMount();
        this._hubViewState.selectedPivot.subscribe(this._onPivotChanged);
        Navigation_Services.getHistoryService().attachNavigate(this._urlStateChangeDelegate);

        this._performance.end();
    }

    public componentWillUnmount(): void {
        Navigation_Services.getHistoryService().detachNavigate(this._urlStateChangeDelegate);
        this._hubViewState.selectedPivot.unsubscribe(this._onPivotChanged);
        super.componentWillUnmount();
    }

    public render(): JSX.Element {
        let hubContent = this._getHubContent();
        return (
            <Fabric className="admin-build-release-hub-view">
                <Hub
                    hubViewState={this._hubViewState}
                    hideFullScreenToggle={true}>
                    <HubHeader />
                    {hubContent}
                </Hub>
            </Fabric>
        );
    }

    private _onPivotChanged = (ev: any, pivotKey: string) => {
        let urlState = Navigation_Services.getHistoryService().getCurrentState();
        if (!Utils_String.equals(ev, urlState.action, true)) {
            urlState.action = ev;
            Navigation_Services.getHistoryService().addHistoryPoint(undefined, urlState, undefined, false, false);
        }
    }

    private _onUrlChange(): void {
        let state = this._getState();
        this._hubViewState.selectedPivot.value = state.tab;
    }

    private _getHubContent(): JSX.Element[] {
        let pivotItems = [];

        if (this._showConcurrentJobsTab) {
            pivotItems.push(
                <PivotBarItem name={BuildResources.ConcurrentJobsText} itemKey={this._concurrentJobsKey} key={this._concurrentJobsKey}>
                    <Fabric> <AdminConcurrentJobsView /> </Fabric>
                </PivotBarItem >
            );
        }

        return (pivotItems);
    }

    private _getState(): AdminBuildAndReleaseHubState {
        if (this.state) {
            return this.state;
        }

        let urlState = Navigation_Services.getHistoryService().getCurrentState();
        return {
            view: urlState.view || this._settingsKey,
            tab: urlState.action || this._settingsKey
        };
    }

    private _urlStateChangeDelegate: IFunctionPPR<any, any, void>;
}

export function load(element: HTMLElement): void {
    ReactDOM.render(<AdminBuildAndReleaseHub />, element);
}
